import * as React from 'react';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { IConfig } from '@cian/config/shared';
import { ITelemetryLogger } from '@cian/telemetry/shared';

import { ApplicationContext } from '../ApplicationContext';
import { BannerContainer } from './containers/BannerContainer';
import { withProvider } from '../../redux';

interface IThankPageBannerProps {
  httpApi: IHttpApi;
  logger: ILogger;
  config: IConfig;
  telemetry: ITelemetryLogger;
}

/**
 * Банер для формы (add-form)
 */
export const ThankPageBanner: React.FC<IThankPageBannerProps> = ({ httpApi, logger, config, telemetry }) => {
  const context = React.useMemo(() => ({ httpApi, logger, config, telemetry }), [httpApi, logger, config, telemetry]);

  return (
    <ApplicationContext.Provider value={context}>
      <BannerContainer />
    </ApplicationContext.Provider>
  );
};

export const ThankPageBannerContainer = withProvider(ThankPageBanner);
